import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Erb } from 'src/app/core/models/erb.model';
import { ErbService } from 'src/app/core/services/erb.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-erbs',
  templateUrl: './erbs.component.html',
  styleUrls: ['./erbs.component.scss'],
})
export class ErbsComponent implements OnInit {
  @ViewChild(GoogleMap, { static: false }) set map(m: GoogleMap) {
    if (m) {
      this.maps = m.googleMap;
    }
  }
  constructor(private erbService: ErbService, httpClient: HttpClient) {
    this.apiLoaded = httpClient
      .jsonp(
        `https://maps.googleapis.com/maps/api/js?key=${environment.googleMaps.key}&libraries=geometry`,
        'callback'
      )
      .pipe(
        map(() => true),
        catchError(() => of(false))
      );
  }

  apiLoaded: Observable<boolean>;
 options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 18,
  };
  maps: any;
  circularProgressiveWait = false;
  erb: Erb = new Erb();
  erbs: Erb[] = [];
  markers: google.maps.Marker[] = [];
  antennas: google.maps.Circle[] = [];

  ngOnInit(): void {}

  searchErb() {
    this.clearMarker();
    this.erbService.getErbs([this.erb]).subscribe((response: any) => {
      this.erbs = response;
      this.erbs.forEach((erb: Erb) => {
        this.createMarker(erb);
      });
      if (this.erbs.length > 0) {
        this.maps.setCenter({
          lat: Number(this.erbs[this.erbs.length - 1].lat),
          lng: Number(this.erbs[this.erbs.length - 1].lng),
        });
      }
    });
  }

  clearMarker() {
    this.markers.forEach((item: google.maps.Marker) => {
      item.setMap(null);
    });
    this.antennas.forEach((item: google.maps.Circle) => {
      item.setMap(null);
    });
    this.antennas = [];
    this.markers = [];
  }

  createMarker(erb: Erb) {
    const marker = new google.maps.Marker({
      position: {
        lat: Number(erb.lat),
        lng: Number(erb.lng),
      },
      icon: '../../../../assets/images/tower.png',
      title: `<p><span style="color: #ff0000;"><strong>${erb.lat}${erb.lng}</strong></span></p>`,
    });
    const antennaCircle = new google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      center: marker.getPosition(),
      radius: 2000,
    });
    antennaCircle.setMap(this.maps);
    marker.setMap(this.maps);
    this.markers.push(marker);
    this.antennas.push(antennaCircle);
  }
}
